import React from 'react';
import { graphql } from 'gatsby';
import { OmInPageCarouselWrapper } from '@om/component-library-react';
import InPageCarouselBannerItem from './InPageCarouselBannerItem';

const InPageCarouselWrapper = ({
    inPageCarouselContent,
    slot
}) => {
    if (!inPageCarouselContent) {
        return '';
    }

    const {
        has_boundary,
        use_heading_as_h1,
        heading,
        caption,
        carousel_items,
    } = inPageCarouselContent;

    return (
        <OmInPageCarouselWrapper
            slot={slot}
            hasBoundary={has_boundary}
        >
            {
                use_heading_as_h1 ? <h1 slot="section-heading"
                    dangerouslySetInnerHTML={{__html: heading}}/> :
                    <span slot="section-heading" dangerouslySetInnerHTML={{__html: heading}}/>
            }
            {
                caption ? <span slot="section-caption"
                    dangerouslySetInnerHTML={{__html: caption}}/> : ''
            }

            {carousel_items ?
                <ul slot="carousel-items">
                    {carousel_items.map((value) => {
                        return (
                            <li key={value.id}>
                                <InPageCarouselBannerItem key={value.id} inPageCarouselBannerItemContent={value}/>
                            </li>
                        )
                    })}
                </ul> : ''
            }
        </OmInPageCarouselWrapper>);
};

export const pageQuery = graphql`
fragment InPageCarouselWrapper on Contentstack_in_page_carousel_wrapper {
    id
    uid
    has_boundary
    use_heading_as_h1
    heading
    caption
    carousel_items {
        ...InPageCarouselBannerItem
    }
}
`;

export default InPageCarouselWrapper;